let lastUrl = '';
let lastCleanedUrl = '';
const pattern = 'trk';

export const getCleanLocationHref = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const currentUrl = window.location.href;

  if (currentUrl === lastUrl) {
    return lastCleanedUrl;
  }

  const urlObj = new URL(currentUrl);
  const paramNames = Array.from(urlObj.searchParams.keys());

  paramNames.forEach(paramName => {
    if (paramName.startsWith(pattern)) {
      urlObj.searchParams.delete(paramName);
    }
  });

  lastUrl = currentUrl;
  lastCleanedUrl = urlObj.toString();

  return lastCleanedUrl;
};
